/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import { useContext, useState } from "react";
import { PatientsContext } from ".";
import { useEffect } from "react";
import fetchHelper from "../../services/fetchHelper";
import { useParams } from "react-router-dom";

const Physician = () => {
  const { i } = useParams();
  const [selectType, setSelectType] = useState("following");
  const { followingPhysicianMetadata, setFollowingPhysicianMetadata, patient, setPatient } =
    useContext(PatientsContext);
  useEffect(() => {
    fetchAvailablePhysicians();
  }, []);

  const generateBody = () => {
    const followingPhysicianObject = followingPhysicianMetadata.selectedFollowingPhysician
      ? {
          followingPhysician: {
            id: followingPhysicianMetadata.selectedFollowingPhysician.id,
          },
        }
      : null;

    const referringPhysicianObject = followingPhysicianMetadata.selectedReferringPhysician
      ? {
          referringPhysician: {
            id: followingPhysicianMetadata.selectedReferringPhysician.id,
          },
        }
      : null;

    return {
      id: i,
      ...followingPhysicianObject,
      ...referringPhysicianObject,
    };
  };

  const save = async () => {
    try {
      if (followingPhysicianMetadata.selectedFollowingPhysician) {
        patient.followingPhysician = { ...followingPhysicianMetadata.selectedFollowingPhysician };
      }

      if (followingPhysicianMetadata.selectedReferringPhysician) {
        patient.referringPhysician = { ...followingPhysicianMetadata.selectedReferringPhysician };
      }
      setPatient(patient);
      setFollowingPhysicianMetadata({ saving: true });
      await fetchHelper.put("/patientmanagement/rest/patients/" + i, generateBody());
      setFollowingPhysicianMetadata({
        oldFollowingPhysician: followingPhysicianMetadata.selectedFollowingPhysician,
        oldReferringPhysician: followingPhysicianMetadata.selectedReferringPhysician,
        openForm: false,
        saved: null,
        saving: false,
      });
    } catch (err) {
      console.log(err);
    }
  };
  const refreshOptions = () => {
    setFollowingPhysicianMetadata({
      selectedFollowingPhysician: patient.followingPhysician || "",
    });
    setFollowingPhysicianMetadata({
      selectedReferringPhysician: patient.referringPhysician || "",
    });
  };

  useEffect(() => {
    if (followingPhysicianMetadata.saved) {
      save();
    }
  }, [followingPhysicianMetadata.saved]);

  useEffect(() => {
    if (followingPhysicianMetadata.openForm) {
      setFollowingPhysicianMetadata({
        openForm: false,
      });
      refreshOptions();
    }
  }, [i]);

  const fetchAvailablePhysicians = async () => {
    try {
      const data = await fetchHelper.get({
        url: "/patientmanagement/rest/users/available-physicians",
      });
      setFollowingPhysicianMetadata({ availablePhysicians: [...data] });
    } catch (err) {
      console.log(err);
    }
  };

  const populateAvailablePhysiciansOptions = () => {
    return followingPhysicianMetadata.availablePhysicians.map((physician) => {
      const temp = [];
      if (physician.rtPaceMakers) temp.push("Pacemakers");
      if (physician.rtDefibrillators) temp.push("Defibrillators");
      return (
        <option key={`${physician.id}-${physician.name}`} value={physician.id}>
          {physician.family}, {physician.name}
          {temp.length > 0 ? ` (${temp.join(", ")})` : ""}
        </option>
      );
    });
  };
  const returnBlankOption = () => {
    if (selectType == "referring" || !followingPhysicianMetadata.selectedFollowingPhysician) {
      return <option value="">Select</option>;
    } else if (
      followingPhysicianMetadata.selectedFollowingPhysician &&
      !followingPhysicianMetadata.selectedReferringPhysician
    ) {
      return <option value="">Select</option>;
    }
  };
  const populateAllAvailablePhysiciansOptions = () => {
    return (
      <>
        {returnBlankOption()}
        {populateAvailablePhysiciansOptions()}
      </>
    );
  };

  return (
    <div className="tabContent location">
      <div className="content">
        <div className="grpHdr">
          <h3>Following Physician</h3>
        </div>
        <div className="row rowStretch location-row">
          <div className="col col-s-100 col-m-100 col50">
            <label>
              <span>Following Physician</span>
              <select
                value={followingPhysicianMetadata.selectedFollowingPhysician?.id || ""}
                onClick={() => setSelectType("following")}
                onChange={(e) => {
                  const { value } = e.target;
                  setFollowingPhysicianMetadata({
                    selectedFollowingPhysician: { id: value },
                    openForm: true,
                  });
                }}
              >
                {populateAllAvailablePhysiciansOptions()}
              </select>
            </label>
          </div>
          <div className="col col-s-100 col-m-100 col50 showBs" />
          <div className="col col-s-100 col-m-100 col50">
            <label>
              <span>Referring Physician</span>
              <select
                value={followingPhysicianMetadata.selectedReferringPhysician?.id || ""}
                onClick={() => setSelectType("referring")}
                onChange={(e) => {
                  const { value } = e.target;
                  setFollowingPhysicianMetadata({
                    selectedReferringPhysician: { id: value },
                    openForm: true,
                  });
                }}
              >
                {populateAllAvailablePhysiciansOptions()}
              </select>
            </label>
          </div>
          <div className="col col-s-100 col-m-100 col50 showBs" />
        </div>
      </div>
    </div>
  );
};

export default Physician;
